import { render, staticRenderFns } from "./systemAdd.vue?vue&type=template&id=4d7441ac&scoped=true&"
import script from "./systemAdd.vue?vue&type=script&lang=js&"
export * from "./systemAdd.vue?vue&type=script&lang=js&"
import style0 from "./systemAdd.vue?vue&type=style&index=0&id=4d7441ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7441ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/thScoreShop/thScoreAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d7441ac')) {
      api.createRecord('4d7441ac', component.options)
    } else {
      api.reload('4d7441ac', component.options)
    }
    module.hot.accept("./systemAdd.vue?vue&type=template&id=4d7441ac&scoped=true&", function () {
      api.rerender('4d7441ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting/systemCreator/systemAdd.vue"
export default component.exports